import { IGif, IProfileUser } from '@giphy/js-types'
import { getGifHeight } from '@giphy/js-util'
import React from 'react'
import { App } from '../app'
import getGifDisplayUrl from './get-gif-display-url'

type MediaTypes = 'gif' | 'sticker' | 'text' | 'emoji' | 'video'

const isEmoji = (gif: IGif) => gif.username?.toLowerCase() === 'emoji'

export const getType = (gif: IGif): MediaTypes => {
    if (isEmoji(gif)) {
        return 'emoji'
    }
    if (gif.is_sticker) {
        return 'sticker'
    }
    return gif.type
}

const emailRendition = {
    gif: 300,
    video: 300,
    emoji: 200,
    text: 400,
    sticker: 200,
}
const standardRendition = {
    gif: 400,
    video: 400,
    emoji: 200,
    text: 400,
    sticker: 400,
}

const getInsertionSize = (small: boolean): { [key in MediaTypes]: number } =>
    small
        ? { ...emailRendition, text: 200, emoji: 75 }
        : {
              gif: 300,
              video: 300,
              emoji: 75,
              text: 300,
              sticker: 300,
          }

const getRenditionTarget = (small: boolean): { [key in MediaTypes]: number } =>
    small ? emailRendition : standardRendition

const isText = (gif: IGif) => gif.type === 'text'

const noAttribution = (gif: IGif) => isEmoji(gif) || isText(gif)

const getGifInsertWidth = (gif: IGif) => {
    const insertionSize = getInsertionSize(App.isEmailClient)
    return insertionSize[getType(gif)]
}

export const getRenditionUrl = (gif: IGif) => {
    const renditionWidth = getRenditionTarget(App.isEmailClient)
    return getGifDisplayUrl(gif, renditionWidth[getType(gif)])
}

type Props = { gif: IGif }

// This is what is rendered as static markup

const GifDisplay = ({ gif }: Props) => {
    const url = getRenditionUrl(gif)
    // display size

    let Footer = () => (
        <>
            <br />
            via <a href={gif.url}>GIPHY</a>
        </>
    )
    const user: IProfileUser = gif.user as IProfileUser
    if (user) {
        const { username } = gif
        const { profile_url: profileUrl, display_name: displayName } = user
        Footer = () => (
            <>
                <br />
                {gif.type === 'video' ? (
                    <>
                        <a href={gif.url}>Watch this GIF with sound on GIPHY Clips</a> via{' '}
                        <a href={profileUrl}>{displayName || username}</a>
                    </>
                ) : (
                    <>
                        via <a href={profileUrl}>{displayName || username}</a> on <a href={gif.url}>GIPHY</a>
                    </>
                )}
            </>
        )
    }
    const width = getGifInsertWidth(gif)
    const height = getGifHeight(gif, width)
    const img = <img src={url} style={{ border: 0, height, width }} />
    return noAttribution(gif) ? (
        img
    ) : (
        <div>
            {img}
            <Footer />
        </div>
    )
}

export default GifDisplay
